import React, { useState, useEffect } from 'react'
import { AlertProvider } from './global-care/context/AlertContext';
import { useAuth } from './global-care/context/AuthContext'
import { Route, Routes } from 'react-router'


import AuthRoutes from './global-care/routes/AuthRoutes'

import LogoutPage from './global-care/app/auth/pages/LogoutPage';
import RechargePage from './global-care/app/admin/business/pages/RechargePage';
import SuspendPage from './global-care/app/admin/business/pages/SuspendPage';

import Error404Page from './global-care/app/errorPages/Error404Page';
import Error401Page from './global-care/app/errorPages/Error401Page';
import ChangePasswordPage from './global-care/app/auth/pages/ChangePasswordPage';
import AdminRoutes from './global-care/routes/AdminRoutes'
import ManagerRoutes from './global-care/routes/ManagerRoutes';
import GrievanceAdminRoutes from './global-care/routes/GrievanceAdminRoutes';
import GrievanceSupervisorRoutes from './global-care/routes/GrievanceSupervisorRoutes';
import GrievanceInspectorRoutes from './global-care/routes/GrievanceInspectorRoutes';



function App() {
    const {isLoggedIn,authUser} = useAuth();
    //console.log("authUSerrole", authUser)
    sessionStorage.removeItem("businessInfo");

    // Disable Right Click Start
    useEffect(() => {
        const handleContextmenu = e => {
            e.preventDefault()
        }
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])
    // Disable Right Click End

    useEffect(()=>{
        sessionStorage.removeItem("staffList");
    },[])
    
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <>
                    { authUser.role == 1 &&
                        <AdminRoutes/>
                    }
                    
                    { authUser.role == 2 &&
                        <ManagerRoutes/>
                    }

                    { authUser.role == 4 &&
                        <GrievanceAdminRoutes/>
                    }

                    { authUser.role == 5 &&
                        <GrievanceSupervisorRoutes />
                    }

                    { authUser.role == 6 &&
                        <GrievanceInspectorRoutes/>
                    }
                    
                    <Routes>
                        {/*Logout */}
                        <Route path="/admin/recharge-page" element={<RechargePage />}></Route>
                        <Route path="/admin/suspend-page" element={<SuspendPage />}></Route>
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                        <Route path="/auth/change-password" element={<ChangePasswordPage />}></Route>
                        <Route path="/404" element={<Error404Page/>}></Route>
                        <Route path="/401" element={<Error401Page/>}></Route>
                    </Routes> 
                </>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App